import React, { Component } from 'react';
import styled from 'styled-components';
import { observer, inject } from 'mobx-react';
import KarteStore from '../../store';
import Viewers from '../Viewers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DivisionDrawer from '../DivisionDrawer';
import AdditionalModal from '../AdditionalModal';
import SheetSelection from '../SheetSelection';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { SheetFormat } from '../../types';

type Props = {
  karte?: KarteStore;
};

@inject('karte')
@observer
export default class Main extends Component<Props> {
  render() {
    const { karte } = this.props;
    if (!karte) {
      return null;
    }

    return (
      <Wrapper>
        <Viewers karte={karte} />
        <DrawerButtonWrapper>
          {karte.sheetFormat === SheetFormat.Customize && (
            <StyledButton onClick={karte.toggleDrawer}>
              {karte.isShowingDrawer ? (
                <FontAwesomeIcon icon={faCaretDown} size="2x" />
              ) : (
                <FontAwesomeIcon icon={faCaretUp} size="2x" />
              )}
            </StyledButton>
          )}
        </DrawerButtonWrapper>
        {karte.isShowingDrawer && <DivisionDrawer karteStore={karte} />}
        {karte.isShowingAdditionalModal && (
          <AdditionalModal divisionNum={karte.numberOfAdditionalDivision} />
        )}
        {karte.isShowingSheetSelection && <SheetSelection />}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const DrawerButtonWrapper = styled.div`
  text-align: center;
  background: #94b9e4;
`;

const StyledButton = styled.button`
  padding: 5px;
  color: #fff;
  width: 100%;
  cursor: pointer;
  background: #94b9e4;
  outline: none;
`;
